'use strict';
var $ = require('../internals/export');

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return URL.prototype.toString.call(this);
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/web.url.to-json.js
// module id = 1308
// module chunks = 1